import OrderServeType from '@/constants/OrderServeType';
import { isEmpty, cloneDeep } from 'lodash';
import PhoneUtils from '@/components/customizeWelcome/utils/phoneUtils';
import NameUtils from '@/components/customizeWelcome/utils/nameUtils';
import Validator from '@/utils/validator';
import CartSubmitUtils from '@/utils/cartSubmitUtils';

const isPersonCountSelected = (shareMealConditionInfo, required): boolean => {
  if (!required) return true;
  if (isEmpty(shareMealConditionInfo)) return false;
  let flag = false;
  shareMealConditionInfo?.forEach((condition: any) => {
    if (Number(condition?.count) > 0) flag = true;
  });
  return flag;
};

const checkSelectedServeTypeValid = (
  selectedServeType,
  selectedTakeOutServeType
) => {
  let isValid = true;

  if (selectedServeType === OrderServeType.DEFAULT) isValid = false;
  if (
    selectedServeType === OrderServeType.TAKE_OUT &&
    selectedTakeOutServeType === OrderServeType.DEFAULT
  ) {
    isValid = false;
  }
  return isValid;
};

const checkWelcomeCTAStyleStatus = (
  webStoreVo,
  orderVo,
  customizeWelcomeReducer
) => {
  if (
    isEmpty(webStoreVo) ||
    isEmpty(orderVo) ||
    isEmpty(customizeWelcomeReducer)
  )
    return false;

  let isValid = true;
  const cloneOrderVo = cloneDeep(orderVo);
  const {
    selectedServeType,
    selectedTakeOutServeType,
    customerName,
    selectedAreaCode,
    customerPhone,
    customerAddress,
    selectedDatePreorderTime,
    selectedTimePreorderTime,
    shareMealCondiction,
  } = customizeWelcomeReducer;

  // 手機
  const isPhoneRequired = PhoneUtils.checkPhoneRequired(
    webStoreVo,
    selectedServeType,
    selectedTakeOutServeType
  );
  // 姓名
  const isNameRequired = NameUtils.checkNameRequired(
    webStoreVo,
    selectedServeType,
    selectedTakeOutServeType
  );
  // 地址
  const isAddressRequired = selectedServeType === OrderServeType.DELIVERY;

  // 共鍋費人數
  const isShareMealCondictionRequired =
    webStoreVo?.shareConditionInfo?.length > 0 &&
    selectedServeType === OrderServeType.DINE_IN;

  // return valid format
  const validateForm = {
    isServeTypeValid: checkSelectedServeTypeValid(
      selectedServeType,
      selectedTakeOutServeType
    ),
    isPhoneValid: Validator.phoneValidator(
      customerPhone,
      'TW',
      isPhoneRequired
    ),
    isNameValid: Validator.nameValidator(customerName, isNameRequired),
    isAddressValid: Validator.addressValidator(
      customerAddress,
      isAddressRequired
    ),
    isShareMealCondictionValid: isPersonCountSelected(
      shareMealCondiction,
      isShareMealCondictionRequired
    ),
  };

  return validateForm;
};

export default checkWelcomeCTAStyleStatus;
